export const externalPlayerEnabled = false;
export const webAnnouncerEnabled = false;
